// Devlopment

// export const SERVER_URL = "http://192.168.1.9";
// export const SERVER_PATH = `${SERVER_URL}/ecom/controllers/api/`;

// export const SERVER_URL = "https://vebbox.in/chakaraartscraft_backend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;
export const SERVER_URL = "https://chakraartandcraft.com/chakaraartscraft_backend";
export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

// export const SERVER_URL = "https://vebbox.in/n999_be";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

// export const SERVER_URL = "http://localhost/n999_be";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;


// localhost

// export const SERVER_URL = "http://localhost/chackra_web_commerce_be";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

// export const SERVER_URL = "http://localhost/chakaraartscraft_backend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;
